// Backend selection, deliberately in its own module with no Supabase import.
//
// store.js needs to know the mode at startup. If it learned that from
// client.js, the whole Supabase SDK would be pulled into the entry chunk and
// the public demo — which never talks to a backend — would download and parse
// it on every visit.

const KEY = 'floatdesk.backend';

// import.meta.env is a Vite construct and is undefined anywhere Vite did not do
// the loading — plain `node tests/*.test.js`, most obviously. Reading through it
// unguarded threw at import time and made the store, and everything downstream
// of it, untestable outside a browser.
const env = import.meta.env ?? {};

export const isConfigured = Boolean(
  env.VITE_SUPABASE_URL && env.VITE_SUPABASE_ANON_KEY,
);

export function backendMode() {
  if (!isConfigured) return 'local';
  try {
    const asked = new URLSearchParams(window.location.search).get('backend');
    if (asked === 'local' || asked === 'supabase') {
      localStorage.setItem(KEY, asked);
      return asked;
    }
    return localStorage.getItem(KEY) || 'local';
  } catch {
    return 'local';
  }
}

export function setBackendMode(mode) {
  try { localStorage.setItem(KEY, mode); } catch { /* private window */ }
}
